module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei7.svg";